export default {

    getAgencies: {
        loading: false,
        error: null,
        data: [],
        status: false,
        message: '',
    }
}